// SPDX-License-Identifier: AGPL-3.0-or-later

import {Slider} from '@app/features/ui/components/Slider';
import styles from '@app/features/voice_scene/components/VoiceSceneAmbienceControl.module.css';
import VoiceSceneSettings from '@app/features/voice_scene/state/VoiceSceneSettings';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {MouseIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

const MOUSE_SENSITIVITY_DESCRIPTOR = msg({
	message: 'Mouse sensitivity',
	comment:
		'Voice call 3D room: label and accessible name of the slider for how fast moving the mouse turns the camera while walking. Remembered on this device.',
});
const MOUSE_SENSITIVITY_VALUE_DESCRIPTOR = msg({
	message: '{percent}%',
	comment:
		'Voice call 3D room: spoken value of the mouse sensitivity slider. {percent} is a number from 10 to 300; 100 is the normal speed.',
});

// How fast the mouse turns the walking camera, 10 to 300, 100 the room's own speed; the setting itself is 0.1 to 3.
export const VoiceSceneMouseSensitivityControl = observer(function VoiceSceneMouseSensitivityControl() {
	const {i18n} = useLingui();
	const label = i18n._(MOUSE_SENSITIVITY_DESCRIPTOR);
	const percent = Math.round(VoiceSceneSettings.mouseSensitivity * 100);
	return (
		<div className={styles.control} data-flx="voice-scene.voice-scene-mouse-sensitivity-control.control">
			<MouseIcon
				className={styles.icon}
				aria-hidden="true"
				data-flx="voice-scene.voice-scene-mouse-sensitivity-control.icon"
			/>
			<span className={styles.label} data-flx="voice-scene.voice-scene-mouse-sensitivity-control.label">
				{label}
			</span>
			<div className={styles.slider} data-flx="voice-scene.voice-scene-mouse-sensitivity-control.slider-wrap">
				<Slider
					mini
					value={percent}
					defaultValue={percent}
					factoryDefaultValue={100}
					minValue={10}
					maxValue={300}
					step={5}
					ariaLabel={label}
					ariaValueText={i18n._(MOUSE_SENSITIVITY_VALUE_DESCRIPTOR, {percent})}
					onValueChange={(value) => VoiceSceneSettings.setMouseSensitivity(Math.round(value) / 100)}
					data-flx="voice-scene.voice-scene-mouse-sensitivity-control.slider"
				/>
			</div>
		</div>
	);
});
